import {Component, OnInit} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, ApiKeyService} from '../_services';
import {ApiKeyComponent} from '../_directives';

@Component({
  moduleId: module.id.toString(),
  templateUrl: './user-api-key.component.html'
})
export class UserApiKeyComponent extends ApiKeyComponent implements OnInit {
  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected keyService: ApiKeyService,
    protected alertService: AlertService
  ) {
    super(router, location, route, keyService, alertService);
  }

  ngOnInit() {
    super.ngOnInit();
  }
}
